<template>
  <v-form ref="loyaltyTierForm" v-model="valid">
    <v-row style="width: 100%" wrap>
      <v-flex shrink px-2>
        <SelectableLoyaltyTierInput
          :loyaltyTier="loyaltyReward.minimum_tier_id"
          :loyaltyTiers="loyaltyTiers"
          label="Minimum Tier"
          @input="function(e){
            loyaltyReward.minimum_tier_id = e;
          }"
        />
      </v-flex>
      <v-flex shrink px-2>
        <SelectableLoyaltyTierInput
          :loyaltyTier="loyaltyReward.maximum_tier_id"
          :loyaltyTiers="loyaltyTiers"
          label="Maximum Tier"
          @input="function(e){
            loyaltyReward.maximum_tier_id = e;
          }"
        />
      </v-flex>
      <v-flex shrink px-2>
        <v-text-field
          :error-messages="errorForField('cost')"
          :rules="loyaltyRewardRules.cost"
          v-model="loyaltyReward.cost"
          type="number"
          class="noStepNumber"
          label="Cost"
          @input="resetError('cost')"
        />
      </v-flex>
      <v-flex shrink px-2>
        <FileInput
          label="Image (Optional)"
          icon="photo_camera"
          accept="image/*"
          :required="true"
          @fileInput="handleImageInput"
        />
      </v-flex>
      <v-flex shrink px-2 pt-2>
        <v-switch v-model="loyaltyReward.enabled" color="primary" label=" Enabled" />
      </v-flex>
    </v-row>
  </v-form>
</template>

<script>
import FileInput from "@/components/widget/input/FileInput.vue";

import SelectableLoyaltyTierInput from "@/components/widget/input/SelectableLoyaltyTierInput.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "loyalty_tier_form",
  components: {
    FileInput,
    SelectableLoyaltyTierInput
  },
  props: {
    loyaltyReward: Object,
    disabled: Boolean,
    errors: { type: Object, default: () => {} }
  },
  data: function() {
    return {
      valid: false,
      loyaltyTiers: [],
      loyaltyRewardRules: {}
    };
  },
  mounted: function() {
    this.getLoyaltyTiers();
  },
  methods: {
    handleImageInput: function(file) {
      this.resetError("image");
      this.$emit("imageInput", file);
    },
    getLoyaltyTiers: async function() {
      try {
        let url = `${this.$store.state.apiUrl}/settings/loyalty_tiers/getAll`;

        let response = await axios.get(url, {
          params: {}
        });
        let loyaltyTiers = response.data.loyalty_tiers;

        loyaltyTiers.sort(function(a, b) {
          return a.point_threshold - b.point_threshold;
        });

        this.loyaltyTiers = loyaltyTiers;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get loyalty tiers " + error);
      }
    },
    errorForField: function(field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function(field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function() {
      this.$refs.loyaltyTierForm.validate();
    }
  },
  watch: {
    valid: function() {
      this.$emit("validityChange", this.valid);
    }
  }
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>